import styled from 'styled-components'
import { rgba, media, colors, radiuses, css } from 'styles'
import StyledUserThumb from 'components/UserThumb/StyledUserThumb'

const StyledFlirt = styled.section`
  font-size: 1.6rem;
  .users {
    margin: 0;
    width: 100%;
  }
  .flirt-tabs {
    display: flex;
    a {
      padding: 0.4rem 0.8rem;
      margin: 0.5rem 1rem 0.5rem 0;
      font-size: 1.4rem;
      border: 0.1rem solid ${colors.textMain};
      border-radius: ${radiuses.medium};
      text-decoration: none;
      color: ${colors.textMain};
      &:not(.active-page) {
        opacity: 0.6;
      }
      &.active-page {
        border-color: ${colors.highlight};
        color: ${colors.mainInverted};
        background-color: ${colors.highlight};
      }
    }
  }

  ${media.tabletOnly`
    .users ${StyledUserThumb} {
      width: calc(100% / 3);
    }
  `}

  ${media.mobile`
    overflow-x: hidden; // right FAB potentially going out after scaling
  `}
`

const tallerFlirts = css`
  .my-half .no-photo {
    padding: calc(58% - 3rem) 3rem;
  }
  .match-half .avatar::before {
    margin-top: 116%; // to get 7/8 like ratio (116 looks better than 114 for many LPs)
  }
`

const FlirtCouple = styled.div`
  margin-bottom: 6.5rem;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0 4.5rem;

  .avatar-img {
    background-color: ${rgba(colors.main, 0.6)};
  }
  .Fab {
    position: absolute;
  }
  .my-half {
    margin-right: 2rem;
  }
  .no-photo {
    font-size: 1.6rem;
  }
  .upgrade {
    text-align: center;
  }
  .cancel {
    right: 0;

    i {
      color: #666666;
      transform: scale(2);
    }
    &:hover i {
      color: ${colors.highlight};
    }
  }
  .approve {
    margin: auto;

    i {
      transform: scale(2) translateY(0.15rem);
      color: #ff4247;
    }
  }

  .match-half {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    .skip {
      margin-left: 2rem;
    }
  }

  ${media.mobile`
    ${tallerFlirts};
    margin-bottom: 3rem;
    padding: 0 3.5rem;

    .my-half {
      display: none;
    }
    .Fab {
      transform: scale(1.5);
      box-shadow: none;
    }
    .approve {
      right: 0rem;
    }
    .cancel {
      right: auto;
      left: 0rem;
    }
  `}

  ${media.phone`
    margin: 0 -1rem;
    .Fab {
      transform: scale(1.2);
    }
  `}
`

export default StyledFlirt
export { FlirtCouple }
